// extracted by mini-css-extract-plugin
export default {"LoginPage__photo":"OnR45PHUIf","LoginLayout__scrollContainer":"oazM6swCda","LoginLayout__heightAndColor":"cQCNtjsuDf"};